module.exports = __webpack_public_path__ + "media/images/default/join_us/nurse-4f5fae98ccc133812c2f79a1681db8b0.jpg";